"use strict";
exports.__esModule = true;
var typeable_1 = require("typeable");
function presence(value) {
    return typeable_1.isPresent(value);
}
exports.presence = presence;



//////////////////
// WEBPACK FOOTER
// ./node_modules/validatable/dist/validators/presence.js
// module id = 368
// module chunks = 0